import styled, { css } from 'styled-components';

export const ContentSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    gap: 16px;
  }
`;

export const BackButton = styled.div`
  cursor: pointer;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px; 
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    color: ${theme.v2.colors.neutral.lowDark};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }      
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }    
  `}
`;
